// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}



/* The Modal (background) */
.popupbg {
  background: #0000004f;
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  overflow: none ;
  /* opacity: 0.7; */
}

/* Modal Content/Box */
.popup {
  position: fixed;
  background: #fff;
  top: 10%;
  left: 50%;
  height: 80vh;
  overflow-y: scroll;
  overflow-x: hidden;
  z-index: 1;
  transform: translateX(-50%);
  width: 80%;
}




/* / cancelButton / */
.cancelorderpopup {
  position: fixed;
  background: #fff;
  top: 20%;
  left: 50%;
  z-index: 1;
  transform: translateX(-50%);
  width: 45%;
}
.cancelpopupoverlay {
  background: #000;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 1;
  right: 0;
  height: 100vh;
  opacity: 0.7;
}
.btnHeight{
  height: -moz-fit-content !important;
  height: fit-content !important;
}
.btnAlign{
  justify-content: end;
}

.orderimg{
  width: 100%;
}
/*  */
.reason_code{
  appearance: none;
}
.itemFDetails select:disabled {
  color: #484848;
}

.dimensionMain{
  width: 65%;
}
.providersModal{
  width: 60%;
}
@media screen and (max-width: 767px) {
  .cancelorderpopup {
    width: 94%;
  }

  .providersModal{
    width: 100%;
  }
  .btnHeight{
    height: -moz-fit-content !important;
    height: fit-content !important;
  }
  .btnAlign{
    justify-content: start;
    padding: 0;
    margin-left: -8px;
  }
  .dimensionMain{
    width: 100%;
  }
}

.allkeys{
  color: black;
  font-size: 15px;
  font-weight: 500;
}

/* styles.css */
.red-ok-button {
  background-color: red !important;
  color: white !important; 
}

.updating-ok-button {
  background-color: #1890ff !important; 
  color: white !important; 
}


@media screen and (max-width: 500px){
  .orderimg{
    width: 100%;
  }
}
@media screen and (max-width: 400px){
  .orderimg{
    width: 80%;
  }
}

@media screen and (max-width: 770px) {
  .PMOrdeList{
    flex-direction: column;
  }
  
}`, "",{"version":3,"sources":["webpack://./src/pages/order/switch.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;;;AAIA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,MAAM;EACN,QAAQ;EACR,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,UAAU;AACZ;;;;;AAKA,qBAAqB;AACrB;EACE,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,MAAM;EACN,UAAU;EACV,QAAQ;EACR,aAAa;EACb,YAAY;AACd;AACA;EACE,mCAA8B;EAA9B,8BAA8B;AAChC;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;AACA,KAAK;AACL;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;EACA;IACE,mCAA8B;IAA9B,8BAA8B;EAChC;EACA;IACE,sBAAsB;IACtB,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;;AAGA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;AAEF","sourcesContent":[".switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n\n.switch input { \n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\ninput:checked + .slider {\n  background-color: #2196F3;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #2196F3;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n\n\n/* The Modal (background) */\n.popupbg {\n  background: #0000004f;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100vh;\n  overflow: none ;\n  /* opacity: 0.7; */\n}\n\n/* Modal Content/Box */\n.popup {\n  position: fixed;\n  background: #fff;\n  top: 10%;\n  left: 50%;\n  height: 80vh;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  z-index: 1;\n  transform: translateX(-50%);\n  width: 80%;\n}\n\n\n\n\n/* / cancelButton / */\n.cancelorderpopup {\n  position: fixed;\n  background: #fff;\n  top: 20%;\n  left: 50%;\n  z-index: 1;\n  transform: translateX(-50%);\n  width: 45%;\n}\n.cancelpopupoverlay {\n  background: #000;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  z-index: 1;\n  right: 0;\n  height: 100vh;\n  opacity: 0.7;\n}\n.btnHeight{\n  height: fit-content !important;\n}\n.btnAlign{\n  justify-content: end;\n}\n\n.orderimg{\n  width: 100%;\n}\n/*  */\n.reason_code{\n  appearance: none;\n}\n.itemFDetails select:disabled {\n  color: #484848;\n}\n\n.dimensionMain{\n  width: 65%;\n}\n.providersModal{\n  width: 60%;\n}\n@media screen and (max-width: 767px) {\n  .cancelorderpopup {\n    width: 94%;\n  }\n\n  .providersModal{\n    width: 100%;\n  }\n  .btnHeight{\n    height: fit-content !important;\n  }\n  .btnAlign{\n    justify-content: start;\n    padding: 0;\n    margin-left: -8px;\n  }\n  .dimensionMain{\n    width: 100%;\n  }\n}\n\n.allkeys{\n  color: black;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n/* styles.css */\n.red-ok-button {\n  background-color: red !important;\n  color: white !important; \n}\n\n.updating-ok-button {\n  background-color: #1890ff !important; \n  color: white !important; \n}\n\n\n@media screen and (max-width: 500px){\n  .orderimg{\n    width: 100%;\n  }\n}\n@media screen and (max-width: 400px){\n  .orderimg{\n    width: 80%;\n  }\n}\n\n@media screen and (max-width: 770px) {\n  .PMOrdeList{\n    flex-direction: column;\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
